import _get from 'lodash/get'
import _has from 'lodash/has'
import _isEmpty from 'lodash/isEmpty'

export const VERIFICATION_SUBTYPES = [
  'provider_yes',
  'provider_yoti',
  'provider_yoti_docscan',
  'provider_sumsub',
]

const VERIFICATION_SUBTYPES_AS_OBJECT = {}
VERIFICATION_SUBTYPES.forEach(subtype => {
  VERIFICATION_SUBTYPES_AS_OBJECT[subtype] = subtype
})

export { VERIFICATION_SUBTYPES_AS_OBJECT }

export class VerificationRecord {
  constructor (record) {
    this._record = record

    this.manual = _get(record, 'data.manual') || {}
    this.kyb = _get(record, 'data.kyb') || {}
    this.logs = _get(record, 'data.manual.logs') || []

    // deprecated - used for old personal_verifications only - moved all new to "data.pd.documents"
    this.documents = {
      selfie: _get(record, 'data.pd.selfie'),
      documentImages: _get(record, 'data.pd.documentImages'),
    }

    this.documentsArray = _get(record, 'data.pd.documents')
    if (!this.documentsArray || (this.documentsArray && this.documentsArray.length === 0)) {
      this.documentsArray = _get(record, 'data.manual.documentsArray')
    }

    this.anchors = _get(record, 'data.pd.anchors')

    this.id = _get(record, 'id', '')
    this.userId = _get(record, 'userId', '')
    this.email = _get(record, 'data.pd.email', '')
    this.type = _get(record, 'type', '')
    this.subtype = _get(record, 'subtype', '')
    this.status = _get(record, 'status', '')
    this.data = _get(record, 'data') || {}
    this.reason = _get(record, 'reason') || {}
    this.comments = _get(record, 'comments') || []

    this.createdAt = _get(record, 'createdAt') || null
    this.updatedAt = _get(record, 'updatedAt') || null

    if (this.isNotEmptyData) {
      if (_has(this.data, 'pd')) {
        delete this.data.pd.selfie
        delete this.data.pd.documentImages
        delete this.data.pd.anchors
        delete this.data.pd.documents
      }

      if (this.isNotEmptyManual && this.isNotEmptyLogs) {
        delete this.data.manual
        delete this.manual.logs
        delete this.manual.comments
      }
    }
  }

  get isNotEmptyData () {
    return !_isEmpty(this.data)
  }

  get isNotEmptyManual () {
    return !_isEmpty(this.data.manual)
  }

  get isNotEmptyKyb () {
    return !_isEmpty(this.data.kyb)
  }

  get isNotEmptyReason () {
    return !_isEmpty(this.reason)
  }

  get isNotEmptyLogs () {
    return !_isEmpty(this.logs)
  }

  get isNotEmptySelfie () {
    return !_isEmpty(this.documents.selfie)
  }

  get isNotEmptyDocImages () {
    return !_isEmpty(this.documents.documentImages)
  }

  get isNotEmptyAnchors () {
    return !_isEmpty(this.anchors)
  }

  get isNotEmptySumsubKyc () {
    return !_isEmpty(this.data.kyc) &&
      this.subtype === VERIFICATION_SUBTYPES_AS_OBJECT.provider_sumsub
  }

  get isNotEmptyDocumentsArray () {
    return !_isEmpty(this.documentsArray)
  }
}
